interface Props {
  artist: Queries.DatoCmsArtist
}

const artistName = ({ artist }: Props) => {
  const title =
    artist.title && artist.title.title ? `${artist.title.title} ` : ''
  const middle = ` ${artist.middleNames} `
  return `${title}${artist.firstName}${middle} ${artist.surname}`
}

export default artistName
